// src/components/ProductDetailModal.js
import React, { useState, useEffect } from 'react';
import { useStore } from '../context/StoreContext';

function ProductDetailModal() {
    const { selectedProduct, closeProductModal } = useStore();
    const [quantity, setQuantity] = useState(1);
    
    useEffect(() => {
        if (selectedProduct) setQuantity(1);
    }, [selectedProduct]);

    // Efecto para bloquear el scroll del fondo (sin cambios)
    useEffect(() => {
        if (selectedProduct) {
            document.body.classList.add('overflow-hidden');
        } else {
            document.body.classList.remove('overflow-hidden');
        }
        return () => document.body.classList.remove('overflow-hidden');
    }, [selectedProduct]);

    const handlePay = () => {
        console.log('Pagar:', selectedProduct.title, 'Cantidad:', quantity);
    };

    const isOpen = !!selectedProduct;

    return (
        // 1. CONTENEDOR PRINCIPAL: Centrado (items-center) y con un padding
        <div 
            className={`fixed inset-0 z-50 flex items-center justify-center p-4 transition-opacity duration-300 ease-in-out ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        >
            {/* Fondo oscuro */}
            <div 
                className="absolute inset-0 bg-black bg-opacity-60" 
                onClick={closeProductModal}
            ></div>

            {/* 2. PANEL: Ahora está centrado, totalmente redondeado, y anima con "scale" */}
            <div 
                className={`relative w-full max-w-4xl bg-[#222222] rounded-2xl shadow-xl transform transition-all duration-300 ease-in-out ${isOpen ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`}
            >
                {/* Botón de Cierre (posicionado sobre el panel) */}
                <button onClick={closeProductModal} className="absolute top-4 right-4 z-10 text-gray-500 hover:text-gray-300">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                </button>

                {/* Contenido del Panel con scroll interno */}
                <div className="max-h-[85vh] overflow-y-auto p-8 md:p-12">
                    {selectedProduct && (
                        // 3. LAYOUT: 2 columnas (se apilan en móvil, lado a lado en desktop)
                        <div className="flex flex-col md:flex-row gap-8 md:gap-12">
                            
                            {/* Columna Izquierda: Imagen */}
                            <div className="w-full md:w-1/2">
                                <div className="bg-[#292929] rounded-lg p-4">
                                    <img 
                                        src={selectedProduct.imageUrl} 
                                        alt={selectedProduct.title} 
                                        // 4. IMAGEN: Respeta el aspect ratio (contain)
                                        className="w-full h-auto max-h-[400px] object-contain rounded-md" 
                                    />
                                </div>
                            </div>
                            
                            {/* Columna Derecha: Contenido */}
                            <div className="w-full md:w-1/2 flex flex-col">
                                <h2 className="text-4xl font-bold text-white mb-4">{selectedProduct.title}</h2>
                                <p className="text-3xl font-bold text-lime-400 mb-6">${selectedProduct.price.toFixed(2)}</p>
                                
                                {/* Descripción (usa flex-grow para empujar el resto hacia abajo) */}
                                <p className="text-gray-300 mb-8 flex-grow">{selectedProduct.description}</p>
                                
                                {/* Sección de Compra (alineada al fondo) */}
                                <div className="flex flex-col gap-6 items-stretch mt-auto">
                                    {/* Selector de Cantidad */}
                                    <div className="flex items-center justify-center gap-4 bg-[#292929] rounded-full p-2">
                                        <button onClick={() => setQuantity(q => Math.max(1, q - 1))} className="w-10 h-10 rounded-full bg-gray-600 text-white text-2xl">-</button>
                                        <span className="text-xl font-bold w-12 text-center">{quantity}</span>
                                        <button onClick={() => setQuantity(q => q + 1)} className="w-10 h-10 rounded-full bg-gray-600 text-white text-2xl">+</button>
                                    </div>
                                    
                                    {/* Botón de Pagar */}
                                    <button onClick={handlePay} className="form-button bg-lime-400 text-black">
                                        Pagar
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ProductDetailModal;